const superAdminTranslations = {
  fi: {
    superAdmin: {
      title: 'Super Admin',
      subtitle: 'Järjestelmänhallinta',
      loading: 'Ladataan järjestelmän tietoja...',
      common: {
        cancel: 'Peruuta',
        save: 'Tallenna',
        saved: 'Tallennettu',
        saving: 'Tallennetaan...',
        loading: 'Ladataan...',
        verify: 'Vahvista',
        verifying: 'Vahvistetaan...',
        sending: 'Lähetetään...',
        testing: 'Testataan...',
        send: 'Lähetä',
        back: 'Takaisin',
        error: 'Virhe',
        networkError: 'Verkkovirhe',
        networkErrorRetry: 'Verkkovirhe – yritä uudelleen',
        noDescription: 'Ei kuvausta',
        active: 'Aktiivinen',
        inactive: 'Ei käytössä',
        on: 'Päällä',
        off: 'Pois',
        activate: 'Aktivoi',
        deactivate: 'Deaktivoi',
        status: 'Status',
        slug: 'Slug',
        description: 'Kuvaus',
        language: 'Kieli',
        created: 'Luotu',
        color: 'Väri',
        members: 'Jäsenet',
        games: 'Pelit',
        actions: 'Toiminnot',
        club: 'Klubi',
        clubs: 'Klubit'
      },
      auth: {
        title: 'SuperAdmin-vahvistus',
        subtitle: 'Lisätarkistus järjestelmänhallintaan',
        requestDescription: 'Lähetämme vahvistuskoodin sähköpostiisi',
        email: 'Sähköposti',
        emailAddress: 'Sähköpostiosoite',
        emailPlaceholder: 'admin@example.com',
        emailRequired: 'Sähköpostiosoite vaaditaan',
        codeSent: 'Vahvistuskoodi lähetetty sähköpostiisi',
        codeRequestError: 'Virhe koodin pyytämisessä',
        codeLabel: 'Vahvistuskoodi',
        codeFromEmail: 'Vahvistuskoodi sähköpostista',
        codePlaceholder: '000000',
        codeHint: 'Syötä sähköpostissa saamasi 6-numeroinen koodi',
        codeRequired: 'Syötä 6-numeroinen koodi',
        invalidCode: 'Virheellinen koodi',
        sendCode: 'Lähetä koodi',
        sendVerificationCode: 'Lähetä vahvistuskoodi',
        resendCode: 'Lähetä uusi koodi',
        resendCountdown: 'Voit pyytää uuden koodin {count} s kuluttua',
        resendPrompt: 'Etkö saanut koodia? Pyydä uusi',
        successTitle: 'Vahvistus onnistui!',
        successRedirect: 'Siirrytään SuperAdmin-näkymään...',
        sessionExpired: 'Sessio vanhentunut',
        sessionExpiredDescription: 'SuperAdmin-istuntosi on vanhentunut. Vahvista henkilöllisyytesi jatkaaksesi.',
        codeSendError: 'Virhe koodin lähettämisessä'
      },
      stats: {
        clubs: 'Klubit',
        users: 'Käyttäjät',
        usersSubtitle: '{active} aktiivista / {inactive} ei-aktiivista',
        sessions: 'Pelisessiot',
        sessionsToday: '{count} tänään',
        activeToday: 'Aktiiviset tänään',
        activeTodaySubtitle: 'Kirjautuneet tai pelanneet'
      },
      tabs: {
        clubs: 'Klubit',
        settings: 'Järjestelmäasetukset',
        ads: 'Globaalit mainokset',
        scoring: 'Pisteytys',
        health: 'Tila'
      },
      clubs: {
        registered: 'Rekisteröidyt klubit ({count})',
        createNew: 'Luo uusi klubi',
        searchPlaceholder: 'Hae nimen tai slugin perusteella...',
        searchResults: '{count} klubia löytyi',
        showMore: 'Näytä lisää ({remaining} jäljellä)',
        viewDetails: 'Näytä tiedot',
        scoring: 'Pisteytys',
        loginAsAdmin: 'Kirjaudu klubin adminina',
        createTitle: 'Luo uusi klubi',
        clubName: 'Klubin nimi',
        clubNamePlaceholder: 'esim. Turun Noppanikkari',
        urlSlug: 'URL-polku (slug)',
        urlSlugPlaceholder: 'esim. turun-noppanikkari',
        descriptionPlaceholder: 'Lyhyt kuvaus klubista...',
        createClub: 'Luo klubi',
        languageFi: 'Suomi',
        languageEn: 'English',
        languageSv: 'Svenska',
        betaFeatures: 'Beta-toiminnot',
        betaFeaturesDescription: 'Uudet toiminnot pysyvät pois päältä kunnes aktivoit ne tälle klubille.',
        planTier: 'Palvelutaso',
        planDescription: 'SuperAdmin voi myöntää Pro-tason ilman laskutusta. Free näkee vain kuluvan kauden.',
        planFree: 'Free — kuluva kausi',
        planPro: 'Pro — kaikki kaudet',
        planGrantedWithoutBilling: 'SuperAdminin myöntämä ilman laskutusta',
        noBetaFeatures: 'Ei rekisteröityjä beta-toimintoja.',
        betaLoadError: 'Beta-toimintojen lataus epäonnistui',
        saveFailed: 'Tallennus epäonnistui'
      },
      scoring: {
        editingClub: 'Muokkaat klubin',
        editingSuffix: 'pisteytystä',
        backToGlobal: 'Takaisin globaaleihin',
        clubSettingsTitle: '{name} – Pisteytysasetukset',
        globalTemplatesTitle: 'Globaalit pisteytysmallit'
      },
      settings: {
        title: 'Globaalit järjestelmäasetukset',
        description: 'Nämä asetukset vaikuttavat kaikkiin klubeihin.',
        sections: {
          smtp: 'Sähköposti (SMTP)',
          ai: 'AI-asetukset',
          prompts: 'Promptit',
          general: 'Yleiset',
          audit: 'Auditointi'
        },
        smtp: {
          loading: 'Ladataan SMTP-asetuksia...',
          title: 'SMTP-sähköpostiasetukset',
          description: 'Käytetään SuperAdmin-vahvistuskoodien ja ilmoitusten lähettämiseen.',
          host: 'SMTP-palvelin',
          hostPlaceholder: 'mail.example.com',
          port: 'Portti',
          portPlaceholder: '465',
          username: 'Käyttäjätunnus',
          usernamePlaceholder: 'user@example.com',
          password: 'Salasana',
          passwordPlaceholder: '••••••••',
          sslTls: 'SSL/TLS',
          sslOption: 'Käytä SSL/TLS (portti 465)',
          startTlsOption: 'STARTTLS (portti 587)',
          fromName: 'Lähettäjän nimi',
          fromNamePlaceholder: 'esim. Board Game League',
          fromEmail: 'Lähettäjän sähköposti',
          fromEmailPlaceholder: 'noreply@example.com',
          fetchError: 'Virhe asetuksien hakemisessa',
          saveSuccess: 'Asetukset tallennettu!',
          saveFailed: 'Tallentaminen epäonnistui',
          saveSettings: 'Tallenna asetukset',
          testTitle: 'Testaa SMTP-yhteys',
          testEmailPlaceholder: 'Testisähköpostiosoite',
          testEmailRequired: 'Syötä testisähköpostiosoite',
          sendTest: 'Lähetä testi',
          testSuccess: 'Testisähköposti lähetetty osoitteeseen {email}',
          testFailed: 'Testi epäonnistui'
        },
        ai: {
          loading: 'Ladataan AI-asetuksia...',
          testTitle: 'Testaa AI-yhteyttä',
          testConnection: 'Testaa yhteys',
          connectionSuccess: 'Yhteys toimii!',
          connectionFailed: 'Yhteys epäonnistui',
          model: 'Malli',
          tipsTitle: 'Vinkkejä',
          tipFlash: 'Nopein ja halvin Gemini-malli',
          tipPro: 'Vanhempi vakaa malli',
          tipPro15: 'Tehokkaampi malli (kalliimpi)'
        },
        prompts: {
          loading: 'Ladataan prompteja...',
          description: 'AI-promptit eri käyttötarkoituksiin. Näitä käytetään AI-avusteisissa toiminnoissa.'
        },
        general: {
          loading: 'Ladataan asetuksia...',
          description: 'Muut järjestelmäasetukset (BGG API, Gemini AI, jne.)'
        }
      },
      health: {
        loadFailed: 'Tilan haku epäonnistui',
        title: 'Järjestelmän tila',
        refresh: 'Päivitä',
        description: 'Korkean tason terveys ja viimeisimmät virheet. Salaisuuksia ei näytetä.',
        database: 'Tietokanta',
        email: 'Sähköposti (SMTP)',
        processUptime: 'Prosessorin käyntiaika',
        memory: 'Muisti (RSS)',
        connectionOk: 'Yhteys OK',
        noConnection: 'Ei yhteyttä',
        hoursMinutes: '{hours} t {minutes} min',
        minutesSeconds: '{minutes} min {seconds} s',
        megabytes: '{count} Mt',
        recentErrors: 'Viimeisimmät virheet',
        noErrors: 'Ei tallennettuja virheitä tämän prosessin aikana.'
      },
      audit: {
        loadFailed: 'Auditin haku epäonnistui',
        saveFailed: 'Tallennus epäonnistui',
        updatedClubs: 'Päivitetty {count} klubia.',
        loading: 'Ladataan auditointia...',
        title: 'Oletukset vs. klubikohtaiset poikkeamat',
        defaultsSummary: 'Oletuskieli {language}, väri {color}, kausi {season}. Beta-toiminnot ovat oletuksena pois.',
        branding: 'Brändäys',
        scoring: 'Pisteytys',
        season: 'Kausi',
        beta: 'Beta',
        defaultValue: 'Oletus',
        deviation: 'Poikkeama',
        platformDefault: 'Alustan oletus',
        customCount: '{count} omaa',
        bulkTitle: 'Levitä beta-asetus klubeille',
        all: 'Kaikki',
        clear: 'Tyhjennä',
        saveSelected: 'Tallenna valituille',
        globalSettingsKeys: 'Globaalit Settings-avaimet'
      },
      ads: {
        title: 'Mainosten kohdennus',
        description: 'Tuotteet näkyvät vain klubeilla, joille ne on kohdennettu. Massajulkaisu vaatii, että klubilla on beta-toiminto',
        betaWarning: 'Julkaisu ei avaa ads_adminia automaattisesti. Aktivoi beta SA-2:lla tai klubin tiedoista.',
        loadFailed: 'Lataus epäonnistui',
        saveFailed: 'Tallennus epäonnistui',
        productUpdated: 'Tuote päivitetty.',
        selectionRequired: 'Valitse vähintään yksi tuote ja yksi klubi.',
        publishFailed: 'Julkaisu epäonnistui',
        publishSuccess: 'Kohdennettu {count} tuotetta/klubia.',
        skippedClubs: 'Ohitettu ilman ads_admin: {clubs}.',
        loading: 'Ladataan mainoksia...',
        products: 'Tuotteet',
        noProducts: 'Ei tuotteita. Luo tuote klubin Mainosten hallinnassa.',
        noSponsor: 'Ei sponsoria',
        noTargeting: 'ei kohdennusta',
        edit: 'Muokkaa',
        clubsTitle: 'Klubit (ads_admin päällä)',
        noClubs: 'Ei klubeja, joilla mainoshallinta on päällä.',
        editProduct: 'Muokkaa tuotetta',
        editHelp: 'Muutos päivittää jaetun katalogituotteen kaikille klubeille, joille se on kohdennettu.',
        name: 'Nimi',
        productUrl: 'Tuote-URL',
        imageUrl: 'Kuva-URL',
        price: 'Hinta',
        salePrice: 'Tarjoushinta',
        productDescription: 'Kuvaus',
        active: 'Aktiivinen',
        saveProduct: 'Tallenna tuote',
        cancel: 'Peruuta',
        publish: 'Julkaise valituille klubeille'
      }
    }
  },
  en: {
    superAdmin: {
      title: 'Super Admin',
      subtitle: 'System administration',
      loading: 'Loading system data...',
      common: {
        cancel: 'Cancel',
        save: 'Save',
        saved: 'Saved',
        saving: 'Saving...',
        loading: 'Loading...',
        verify: 'Verify',
        verifying: 'Verifying...',
        sending: 'Sending...',
        testing: 'Testing...',
        send: 'Send',
        back: 'Back',
        error: 'Error',
        networkError: 'Network error',
        networkErrorRetry: 'Network error – please try again',
        noDescription: 'No description',
        active: 'Active',
        inactive: 'Inactive',
        on: 'On',
        off: 'Off',
        activate: 'Activate',
        deactivate: 'Deactivate',
        status: 'Status',
        slug: 'Slug',
        description: 'Description',
        language: 'Language',
        created: 'Created',
        color: 'Colour',
        members: 'Members',
        games: 'Games',
        actions: 'Actions',
        club: 'Club',
        clubs: 'Clubs'
      },
      auth: {
        title: 'SuperAdmin verification',
        subtitle: 'Additional check for system administration',
        requestDescription: 'We will send a verification code to your email',
        email: 'Email',
        emailAddress: 'Email address',
        emailPlaceholder: 'admin@example.com',
        emailRequired: 'Email address is required',
        codeSent: 'Verification code sent to your email',
        codeRequestError: 'Error requesting code',
        codeLabel: 'Verification code',
        codeFromEmail: 'Verification code from email',
        codePlaceholder: '000000',
        codeHint: 'Enter the 6-digit code you received by email',
        codeRequired: 'Enter the 6-digit code',
        invalidCode: 'Invalid code',
        sendCode: 'Send code',
        sendVerificationCode: 'Send verification code',
        resendCode: 'Send new code',
        resendCountdown: 'You can request a new code in {count} s',
        resendPrompt: "Didn't receive a code? Request a new one",
        successTitle: 'Verification successful!',
        successRedirect: 'Redirecting to SuperAdmin view...',
        sessionExpired: 'Session expired',
        sessionExpiredDescription: 'Your SuperAdmin session has expired. Verify your identity to continue.',
        codeSendError: 'Error sending code'
      },
      stats: {
        clubs: 'Clubs',
        users: 'Users',
        usersSubtitle: '{active} active / {inactive} inactive',
        sessions: 'Game sessions',
        sessionsToday: '{count} today',
        activeToday: 'Active today',
        activeTodaySubtitle: 'Logged in or played'
      },
      tabs: {
        clubs: 'Clubs',
        settings: 'System settings',
        ads: 'Global ads',
        scoring: 'Scoring',
        health: 'Status'
      },
      clubs: {
        registered: 'Registered clubs ({count})',
        createNew: 'Create new club',
        searchPlaceholder: 'Search by name or slug...',
        searchResults: '{count} clubs found',
        showMore: 'Show more ({remaining} remaining)',
        viewDetails: 'View details',
        scoring: 'Scoring',
        loginAsAdmin: 'Log in as club admin',
        createTitle: 'Create new club',
        clubName: 'Club name',
        clubNamePlaceholder: 'e.g. Turku Board Gamers',
        urlSlug: 'URL path (slug)',
        urlSlugPlaceholder: 'e.g. turku-board-gamers',
        descriptionPlaceholder: 'Short description of the club...',
        createClub: 'Create club',
        languageFi: 'Finnish',
        languageEn: 'English',
        languageSv: 'Swedish',
        betaFeatures: 'Beta features',
        betaFeaturesDescription: 'New features remain disabled until you enable them for this club.',
        planTier: 'Service plan',
        planDescription: 'SuperAdmin can grant Pro without billing. Free includes only the current season.',
        planFree: 'Free — current season',
        planPro: 'Pro — all seasons',
        planGrantedWithoutBilling: 'Granted by SuperAdmin without billing',
        noBetaFeatures: 'No registered beta features.',
        betaLoadError: 'Failed to load beta features',
        saveFailed: 'Save failed'
      },
      scoring: {
        editingClub: 'Editing club',
        editingSuffix: 'scoring settings',
        backToGlobal: 'Back to global',
        clubSettingsTitle: '{name} – Scoring settings',
        globalTemplatesTitle: 'Global scoring templates'
      },
      settings: {
        title: 'Global system settings',
        description: 'These settings affect all clubs.',
        sections: {
          smtp: 'Email (SMTP)',
          ai: 'AI settings',
          prompts: 'Prompts',
          general: 'General',
          audit: 'Audit'
        },
        smtp: {
          loading: 'Loading SMTP settings...',
          title: 'SMTP email settings',
          description: 'Used to send SuperAdmin verification codes and notifications.',
          host: 'SMTP server',
          hostPlaceholder: 'mail.example.com',
          port: 'Port',
          portPlaceholder: '465',
          username: 'Username',
          usernamePlaceholder: 'user@example.com',
          password: 'Password',
          passwordPlaceholder: '••••••••',
          sslTls: 'SSL/TLS',
          sslOption: 'Use SSL/TLS (port 465)',
          startTlsOption: 'STARTTLS (port 587)',
          fromName: 'Sender name',
          fromNamePlaceholder: 'e.g. Board Game League',
          fromEmail: 'Sender email',
          fromEmailPlaceholder: 'noreply@example.com',
          fetchError: 'Error fetching settings',
          saveSuccess: 'Settings saved!',
          saveFailed: 'Save failed',
          saveSettings: 'Save settings',
          testTitle: 'Test SMTP connection',
          testEmailPlaceholder: 'Test email address',
          testEmailRequired: 'Enter a test email address',
          sendTest: 'Send test',
          testSuccess: 'Test email sent to {email}',
          testFailed: 'Test failed'
        },
        ai: {
          loading: 'Loading AI settings...',
          testTitle: 'Test AI connection',
          testConnection: 'Test connection',
          connectionSuccess: 'Connection works!',
          connectionFailed: 'Connection failed',
          model: 'Model',
          tipsTitle: 'Tips',
          tipFlash: 'Fastest and cheapest Gemini model',
          tipPro: 'Older stable model',
          tipPro15: 'More capable model (more expensive)'
        },
        prompts: {
          loading: 'Loading prompts...',
          description: 'AI prompts for different use cases. Used in AI-assisted features.'
        },
        general: {
          loading: 'Loading settings...',
          description: 'Other system settings (BGG API, Gemini AI, etc.)'
        }
      },
      health: {
        loadFailed: 'Failed to load system status',
        title: 'System status',
        refresh: 'Refresh',
        description: 'High-level health and the latest errors. Secrets are not shown.',
        database: 'Database',
        email: 'Email (SMTP)',
        processUptime: 'Process uptime',
        memory: 'Memory (RSS)',
        connectionOk: 'Connection OK',
        noConnection: 'No connection',
        hoursMinutes: '{hours} h {minutes} min',
        minutesSeconds: '{minutes} min {seconds} s',
        megabytes: '{count} MB',
        recentErrors: 'Latest errors',
        noErrors: 'No errors recorded during this process.'
      },
      audit: {
        loadFailed: 'Failed to load audit',
        saveFailed: 'Save failed',
        updatedClubs: 'Updated {count} clubs.',
        loading: 'Loading audit...',
        title: 'Defaults vs. club-specific overrides',
        defaultsSummary: 'Default language {language}, colour {color}, season {season}. Beta features are off by default.',
        branding: 'Branding',
        scoring: 'Scoring',
        season: 'Season',
        beta: 'Beta',
        defaultValue: 'Default',
        deviation: 'Override',
        platformDefault: 'Platform default',
        customCount: '{count} custom',
        bulkTitle: 'Apply beta setting to clubs',
        all: 'All',
        clear: 'Clear',
        saveSelected: 'Save for selected',
        globalSettingsKeys: 'Global Settings keys'
      },
      ads: {
        title: 'Ad targeting',
        description: 'Products are shown only in clubs they target. Bulk publishing requires the club to have the beta feature',
        betaWarning: 'Publishing does not enable ads_admin automatically. Enable the beta through SA-2 or the club details.',
        loadFailed: 'Loading failed',
        saveFailed: 'Save failed',
        productUpdated: 'Product updated.',
        selectionRequired: 'Select at least one product and one club.',
        publishFailed: 'Publishing failed',
        publishSuccess: 'Targeted {count} product/club pairs.',
        skippedClubs: 'Skipped without ads_admin: {clubs}.',
        loading: 'Loading ads...',
        products: 'Products',
        noProducts: 'No products. Create a product in the club Ad management view.',
        noSponsor: 'No sponsor',
        noTargeting: 'not targeted',
        edit: 'Edit',
        clubsTitle: 'Clubs (ads_admin enabled)',
        noClubs: 'No clubs have ad management enabled.',
        editProduct: 'Edit product',
        editHelp: 'The change updates the shared catalogue product for every club it targets.',
        name: 'Name',
        productUrl: 'Product URL',
        imageUrl: 'Image URL',
        price: 'Price',
        salePrice: 'Sale price',
        productDescription: 'Description',
        active: 'Active',
        saveProduct: 'Save product',
        cancel: 'Cancel',
        publish: 'Publish to selected clubs'
      }
    }
  },
  sv: {
    superAdmin: {
      title: 'Super Admin',
      subtitle: 'Systemadministration',
      loading: 'Laddar systemdata...',
      common: {
        cancel: 'Avbryt',
        save: 'Spara',
        saved: 'Sparat',
        saving: 'Sparar...',
        loading: 'Laddar...',
        verify: 'Verifiera',
        verifying: 'Verifierar...',
        sending: 'Skickar...',
        testing: 'Testar...',
        send: 'Skicka',
        back: 'Tillbaka',
        error: 'Fel',
        networkError: 'Nätverksfel',
        networkErrorRetry: 'Nätverksfel – försök igen',
        noDescription: 'Ingen beskrivning',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        on: 'På',
        off: 'Av',
        activate: 'Aktivera',
        deactivate: 'Inaktivera',
        status: 'Status',
        slug: 'Slug',
        description: 'Beskrivning',
        language: 'Språk',
        created: 'Skapad',
        color: 'Färg',
        members: 'Medlemmar',
        games: 'Spel',
        actions: 'Åtgärder',
        club: 'Klubb',
        clubs: 'Klubbar'
      },
      auth: {
        title: 'SuperAdmin-verifiering',
        subtitle: 'Extra kontroll för systemadministration',
        requestDescription: 'Vi skickar en verifieringskod till din e-post',
        email: 'E-post',
        emailAddress: 'E-postadress',
        emailPlaceholder: 'admin@example.com',
        emailRequired: 'E-postadress krävs',
        codeSent: 'Verifieringskod skickad till din e-post',
        codeRequestError: 'Fel vid begäran om kod',
        codeLabel: 'Verifieringskod',
        codeFromEmail: 'Verifieringskod från e-post',
        codePlaceholder: '000000',
        codeHint: 'Ange den 6-siffriga koden du fick via e-post',
        codeRequired: 'Ange den 6-siffriga koden',
        invalidCode: 'Ogiltig kod',
        sendCode: 'Skicka kod',
        sendVerificationCode: 'Skicka verifieringskod',
        resendCode: 'Skicka ny kod',
        resendCountdown: 'Du kan begära en ny kod om {count} s',
        resendPrompt: 'Fick du ingen kod? Begär en ny',
        successTitle: 'Verifiering lyckades!',
        successRedirect: 'Omdirigerar till SuperAdmin-vyn...',
        sessionExpired: 'Sessionen har gått ut',
        sessionExpiredDescription: 'Din SuperAdmin-session har gått ut. Verifiera din identitet för att fortsätta.',
        codeSendError: 'Fel vid sändning av kod'
      },
      stats: {
        clubs: 'Klubbar',
        users: 'Användare',
        usersSubtitle: '{active} aktiva / {inactive} inaktiva',
        sessions: 'Spelsessioner',
        sessionsToday: '{count} idag',
        activeToday: 'Aktiva idag',
        activeTodaySubtitle: 'Inloggade eller spelat'
      },
      tabs: {
        clubs: 'Klubbar',
        settings: 'Systeminställningar',
        ads: 'Globala annonser',
        scoring: 'Poängsättning',
        health: 'Status'
      },
      clubs: {
        registered: 'Registrerade klubbar ({count})',
        createNew: 'Skapa ny klubb',
        searchPlaceholder: 'Sök på namn eller slug...',
        searchResults: '{count} klubbar hittades',
        showMore: 'Visa fler ({remaining} kvar)',
        viewDetails: 'Visa detaljer',
        scoring: 'Poängsättning',
        loginAsAdmin: 'Logga in som klubbadmin',
        createTitle: 'Skapa ny klubb',
        clubName: 'Klubbnamn',
        clubNamePlaceholder: 't.ex. Åbo Brädspelare',
        urlSlug: 'URL-sökväg (slug)',
        urlSlugPlaceholder: 't.ex. abo-bradspelare',
        descriptionPlaceholder: 'Kort beskrivning av klubben...',
        createClub: 'Skapa klubb',
        languageFi: 'Finska',
        languageEn: 'Engelska',
        languageSv: 'Svenska',
        betaFeatures: 'Betafunktioner',
        betaFeaturesDescription: 'Nya funktioner förblir avstängda tills du aktiverar dem för denna klubb.',
        planTier: 'Tjänstenivå',
        planDescription: 'SuperAdmin kan bevilja Pro utan fakturering. Free omfattar endast aktuell säsong.',
        planFree: 'Free — aktuell säsong',
        planPro: 'Pro — alla säsonger',
        planGrantedWithoutBilling: 'Beviljad av SuperAdmin utan fakturering',
        noBetaFeatures: 'Inga registrerade betafunktioner.',
        betaLoadError: 'Det gick inte att ladda betafunktioner',
        saveFailed: 'Sparning misslyckades'
      },
      scoring: {
        editingClub: 'Du redigerar klubben',
        editingSuffix: 'poänginställningar',
        backToGlobal: 'Tillbaka till globala',
        clubSettingsTitle: '{name} – Poängsättningsinställningar',
        globalTemplatesTitle: 'Globala poängsättningsmallar'
      },
      settings: {
        title: 'Globala systeminställningar',
        description: 'Dessa inställningar påverkar alla klubbar.',
        sections: {
          smtp: 'E-post (SMTP)',
          ai: 'AI-inställningar',
          prompts: 'Prompter',
          general: 'Allmänt',
          audit: 'Granskning'
        },
        smtp: {
          loading: 'Laddar SMTP-inställningar...',
          title: 'SMTP-e-postinställningar',
          description: 'Används för att skicka SuperAdmin-verifieringskoder och aviseringar.',
          host: 'SMTP-server',
          hostPlaceholder: 'mail.example.com',
          port: 'Port',
          portPlaceholder: '465',
          username: 'Användarnamn',
          usernamePlaceholder: 'user@example.com',
          password: 'Lösenord',
          passwordPlaceholder: '••••••••',
          sslTls: 'SSL/TLS',
          sslOption: 'Använd SSL/TLS (port 465)',
          startTlsOption: 'STARTTLS (port 587)',
          fromName: 'Avsändarens namn',
          fromNamePlaceholder: 't.ex. Board Game League',
          fromEmail: 'Avsändarens e-post',
          fromEmailPlaceholder: 'noreply@example.com',
          fetchError: 'Fel vid hämtning av inställningar',
          saveSuccess: 'Inställningar sparade!',
          saveFailed: 'Sparning misslyckades',
          saveSettings: 'Spara inställningar',
          testTitle: 'Testa SMTP-anslutning',
          testEmailPlaceholder: 'Test-e-postadress',
          testEmailRequired: 'Ange en test-e-postadress',
          sendTest: 'Skicka test',
          testSuccess: 'Test-e-post skickad till {email}',
          testFailed: 'Testet misslyckades'
        },
        ai: {
          loading: 'Laddar AI-inställningar...',
          testTitle: 'Testa AI-anslutning',
          testConnection: 'Testa anslutning',
          connectionSuccess: 'Anslutningen fungerar!',
          connectionFailed: 'Anslutningen misslyckades',
          model: 'Modell',
          tipsTitle: 'Tips',
          tipFlash: 'Snabbaste och billigaste Gemini-modellen',
          tipPro: 'Äldre stabil modell',
          tipPro15: 'Mer kapabel modell (dyrare)'
        },
        prompts: {
          loading: 'Laddar prompter...',
          description: 'AI-prompter för olika användningsområden. Används i AI-assisterade funktioner.'
        },
        general: {
          loading: 'Laddar inställningar...',
          description: 'Övriga systeminställningar (BGG API, Gemini AI, m.m.)'
        }
      },
      health: {
        loadFailed: 'Det gick inte att hämta systemstatus',
        title: 'Systemstatus',
        refresh: 'Uppdatera',
        description: 'Övergripande hälsa och de senaste felen. Hemligheter visas inte.',
        database: 'Databas',
        email: 'E-post (SMTP)',
        processUptime: 'Processens drifttid',
        memory: 'Minne (RSS)',
        connectionOk: 'Anslutning OK',
        noConnection: 'Ingen anslutning',
        hoursMinutes: '{hours} t {minutes} min',
        minutesSeconds: '{minutes} min {seconds} s',
        megabytes: '{count} MB',
        recentErrors: 'Senaste fel',
        noErrors: 'Inga fel har registrerats under denna process.'
      },
      audit: {
        loadFailed: 'Det gick inte att hämta granskningen',
        saveFailed: 'Sparningen misslyckades',
        updatedClubs: 'Uppdaterade {count} klubbar.',
        loading: 'Laddar granskning...',
        title: 'Standardvärden jämfört med klubbspecifika avvikelser',
        defaultsSummary: 'Standardspråk {language}, färg {color}, säsong {season}. Betafunktioner är avstängda som standard.',
        branding: 'Varumärke',
        scoring: 'Poängräkning',
        season: 'Säsong',
        beta: 'Beta',
        defaultValue: 'Standard',
        deviation: 'Avvikelse',
        platformDefault: 'Plattformens standard',
        customCount: '{count} egna',
        bulkTitle: 'Tillämpa betainställning på klubbar',
        all: 'Alla',
        clear: 'Rensa',
        saveSelected: 'Spara för valda',
        globalSettingsKeys: 'Globala Settings-nycklar'
      },
      ads: {
        title: 'Annonsinriktning',
        description: 'Produkter visas endast i klubbar som de har riktats till. Masspublicering kräver att klubben har betafunktionen',
        betaWarning: 'Publicering aktiverar inte ads_admin automatiskt. Aktivera betan via SA-2 eller klubbuppgifterna.',
        loadFailed: 'Laddningen misslyckades',
        saveFailed: 'Sparningen misslyckades',
        productUpdated: 'Produkten uppdaterades.',
        selectionRequired: 'Välj minst en produkt och en klubb.',
        publishFailed: 'Publiceringen misslyckades',
        publishSuccess: 'Riktade {count} produkt-/klubbpar.',
        skippedClubs: 'Hoppade över utan ads_admin: {clubs}.',
        loading: 'Laddar annonser...',
        products: 'Produkter',
        noProducts: 'Inga produkter. Skapa en produkt i klubbens annonsadministration.',
        noSponsor: 'Ingen sponsor',
        noTargeting: 'ingen inriktning',
        edit: 'Redigera',
        clubsTitle: 'Klubbar (ads_admin aktiverat)',
        noClubs: 'Inga klubbar har annonsadministration aktiverad.',
        editProduct: 'Redigera produkt',
        editHelp: 'Ändringen uppdaterar den delade katalogprodukten för alla klubbar som den riktats till.',
        name: 'Namn',
        productUrl: 'Produkt-URL',
        imageUrl: 'Bild-URL',
        price: 'Pris',
        salePrice: 'Reapris',
        productDescription: 'Beskrivning',
        active: 'Aktiv',
        saveProduct: 'Spara produkt',
        cancel: 'Avbryt',
        publish: 'Publicera till valda klubbar'
      }
    }
  }
};

export function interpolate(template, vars = {}) {
  return Object.entries(vars).reduce(
    (result, [key, value]) => result.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value)),
    template
  );
}

export default superAdminTranslations;
